import axios from "axios";
import store from "../../store/index";
import router from '../../router'
// import stringify from '../utils/UrlEncoder';
/**
 *
 * @param {*} params Gidecek parametreler
 */
export async function Provider(params) {
  try {
    // Varsa dil parametresini gönder
    const lang = router.currentRoute.query.lang;

    const req = { data: params, lang };
    const res = await axios({
      url: `${process.env.VUE_APP_API_URL}?m=${params.methodName}`,
      data: req,
      method: "POST",
      headers: {
        Authorization: `Bearer ${store.state.User.UserLogin.token}`
      },
      // auth: {
      //   username: process.env.VUE_APP_API_USER,
      //   password: process.env.VUE_APP_API_PASS
      // }
    });
    return res.data;
  } catch (err) {
    console.log("error", err);
  }
}
